<template>
  <div class="about text-white mb-80 leading-loose tracking-widest">
    <div class="flex flex-col space-y-10">
      <h1 class="text-3xl font-semibold w-full text-center">
        NFT20 Leaderboard
      </h1>
      <h2 class="text-center text-xl w-8/12 mx-auto">
        This is work in progress, no one yet knows what the leaderboard is for
        or how to qualify but many users can guess
      </h2>
    </div>

    <div class="flex flex-col">
      <div class="flex flex-col w-auto w-3/4 mx-auto space-y-2">
        <div
          v-for="(user, i) in leaderboard"
          :key="i"
          class="flex mt-10 flex w-full mx-auto space-x-0 justify-between items-end border-b border-gray-700 py-2"
        >
          <div class="w-1/12 flex justify-self-start text-xl">{{ i + 1 }}.</div>
          <div class="w-10/12 flex items-end">
            <div v-if="user.avatar" class="flex">
              <router-link to="/nfts">
                <img :src="user.avatar" alt="" class="h-14 pr-3" />
              </router-link>
            </div>
            <div class="flex text-xs md:text-base">
              <a
                class="overflow-ellipsis overflow-hidden ..."
                target="_blank"
                :href="`https://etherscan.io/address/${user.address}`"
                >{{ user.name ? user.name : user.address }}</a
              >
            </div>
          </div>
          <div class="w-1/12 flex text-2xl font-semibold text-secondary">
            {{ user.score }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Leaderboard",
  components: {},
  data: function () {
    return {
      leaderboard: [],
    };
  },
  beforeMount: async function () {},
  methods: {},
  computed: {},
  mounted: async function () {
    let { data } = await axios.get(
      "https://api.nft20.io/leaderboard?perPage=1000"
    );
    this.leaderboard = data.data;
  },
};
</script>


<style scoped>
p {
  padding: 0.6rem 0rem;
}

/* video {
  -moz-box-shadow: 0 -22px 22px -22px rgba(0, 0, 0, 0.8) inset;
  -webkit-box-shadow: 0 -22px 22px -22px rgba(0, 0, 0, 0.8) inset;
  box-shadow: 0 -100px 100px -100px rgba(0, 0, 0, 0.8) inset;
} */
</style>